import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import EsmsPage from '../../components/EsmsPage';
import DownloadsTable from './DownloadsTable';

class DownloadsPage extends Component {
    handlePageRoute = () => {
        const { history, location } = this.props;

        history.push('/iothub' + location.search);
    }

    render() {
        let {
            companyInfo
        } = this.props;

        return (
            <React.Fragment>
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    title="Downloads"
                    handlers={[this.handlePageRoute]}
                >
                    <DownloadsTable
                        companyInfo={companyInfo}
                    />
                </EsmsPage>
            </React.Fragment>
        );
    }
}

export const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo
    };
};

const mapDispatchToProps = {

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DownloadsPage));
